import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Spacer, Title, Message } from 'src/core/components';

import { ProgressTabs } from 'src/components/OligoDNA/components';
import { DNA, COUNTRY_CODE_JAPAN } from 'src/constants/forms';
import { DnaOligo } from 'src/models';
import { getCountryCode } from 'src/utils';
import { selectDetailsData } from 'src/core/redux/selectors';
import { User } from 'src/core/models';

import messages from './messages';
import './OligoDNAStyle.scss';

const OligoDNA = ({ userDetails }) => {
  let value = DNA;
  const dnaType = DnaOligo.getDNAType(userDetails);

  if (dnaType) {
    value = `Ampliseq ${DnaOligo.getAmpliseqType(dnaType)}`;
  }

  let message = { ...messages.filesInstructions, values: { value } };

  if (getCountryCode() === COUNTRY_CODE_JAPAN) {
    message = { ...messages.japanFilesInstructions, values: { value } };
  }

  return (
    <>
      <Spacer top={20} bottom={8}>
        <Title size="1" font="thin" message={{ ...messages.title, values: { value } }} />
      </Spacer>
      <div className="dna-files-details">
        <div className="dna-files-details__description">
          <Message message={message} />
        </div>
      </div>
      <Spacer bottom={48} />
      <ProgressTabs dnaType={dnaType} />
    </>
  );
};

OligoDNA.propTypes = {
  userDetails: PropTypes.object,
};

const mapStateToProps = (state) => ({
  userDetails: selectDetailsData(User)(state),
});

export default connect(mapStateToProps)(OligoDNA);
